const posSlant = () => {
  let $ = jQuery;
  let $bgSlant = $('#bg-slant');
  let $bgSlantParent = $('.contact-us-main');
  if ($bgSlant.length && $bgSlantParent.length) {
    let parentHeight = parseInt($bgSlantParent.css('height'));
    let parentTop = $bgSlantParent.offset().top;
    $bgSlant.css('top', String(parentTop + (parentHeight / 2)) + 'px');
  }
}

posSlant();

window.addEventListener('resize', posSlant);
